import { gql } from '@apollo/client'

const CONSTRUCTION_SITES = gql`
  query constructionSites {
    constructionSites(condition: { isSite: false }) {
      nodes {
        address
        city
        code
        id
        postcode
      }
    }
  }
`

const CONSTRUCTION_SITES_BDN = gql`
  query constructionSites {
    constructionSites(condition: { isSite: true }) {
      nodes {
        address
        city
        code
        id
        postcode
      }
    }
  }
`

const CREATE_CONSTRUCTION_SITE = gql`
  mutation createConstructionSite(
    $code: String!
    $address: String
    $city: String
    $postcode: String
  ) {
    createConstructionSite(
      input: {
        constructionSite: { code: $code, address: $address, city: $city, postcode: $postcode }
      }
    ) {
      constructionSite {
        id
      }
    }
  }
`

const UPDATE_CONSTRUCTION_SITE = gql`
  mutation updateConstructionSite($id: UUID!, $address: String, $city: String, $postcode: String) {
    updateConstructionSite(
      input: { patch: { address: $address, city: $city, postcode: $postcode }, id: $id }
    ) {
      clientMutationId
    }
  }
`

export default {
  CONSTRUCTION_SITES,
  CONSTRUCTION_SITES_BDN,
  CREATE_CONSTRUCTION_SITE,
  UPDATE_CONSTRUCTION_SITE,
}